import React, { useState, useEffect, useContext, useRef } from "react";
import "./OurProduct.css";
import { Col, Container, Row } from "react-bootstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Product_Card from "../../Common-Component/Product_Card/Product_Card";
import { Context } from "../../../utils/context";
import { Products } from "../../../utils/apis/Product/Product";
import DoubleHeading from "../../Common-Component/DoubleHeading/DoubleHeading";
import Loader_lottie from "../../Animation/Loader_lottie/Loader_lottie";
import { Link } from "react-router-dom";
import { ShimmerThumbnail } from "react-shimmer-effects";

library.add(fas);

const OurProduct = () => {

  const { IMG_URL } = useContext(Context);
  const [products, setProducts] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [numToShow, setNumToShow] = useState(5);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 575);
  const [loading, setLoading] = useState(true); // 👈 Loader state

  const sectionRef = useRef(null);

  const getProduct = async () => {
    setLoading(true); // 👈 Start loader
    const res = await Products();
    if (res?.success) {
      await setProducts(res?.data?.data);
      await setNumToShow(window.innerWidth < 575 ? 2 : 5);
      await setShowAll(false);
    }
    setLoading(false); // 👈 Stop loader
  };

  useEffect(() => {
    getProduct();

    const handleResize = async () => {
      const mobile = window.innerWidth < 575;
      await setIsMobile(mobile);
      await setNumToShow(mobile ? 10 : 5);
      await setShowAll(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);



  if (loading) {
    return <ShimmerThumbnail rounded />;
  }

  return (
    <section className="our-product" ref={sectionRef}>
      <Container fluid>
        <div className="mb-4 mt-3">
          <DoubleHeading heading={"All Products"} />
        </div>

        {/* Products Grid */}
        <div className="desktop_view_product_category_slider " ref={sectionRef}>
          <Row>
            {products.slice(0, numToShow).map((product, index) => {
              const price =
                product?.product_multiple_mains?.[0]
                  ?.product_multiple_variants?.[0]?.mrp ||
                product?.product_variants?.[0]?.mrp;

              const cutprice =
                product?.product_multiple_mains?.[0]
                  ?.product_multiple_variants?.[0]?.cutting_price ||
                product?.product_variants?.[0]?.cutting_price;

              return (
                <Col
                  key={index}
                  xxl={3}
                  xl={3}
                  lg={3}
                  md={4}
                  sm={4}
                  xs={6}
                  className="custom_class_product">
                  <Product_Card
                    image={IMG_URL + product?.image1}
                    text={product?.name}
                    product_id={product?.id}
                    subText={product?.short_description}
                    price={price}
                    cutprice={cutprice}
                    newest={product?.newest}
                    variant_id={product?.product_variants?.[0]?.id}
                    m_variant_id={
                      product?.product_multiple_mains?.[0]
                        ?.product_multiple_variants?.[0]?.id
                    }
                  />
                </Col>
              );
            })}
          </Row>
        </div>

        <Link to={"/all-products"}>
          <div className="view-all mb-5">
            <p>View More</p>
          </div>
        </Link>
      </Container>
    </section>
  );
};

export default OurProduct;
